import * as oidc from 'oidc-client';

export const configure = (config) => {
  if (config) {
    return new oidc.UserManager({
      authority: config.AUTHORITY,
      redirect_uri: config.REDIRECT_URL,
      post_logout_redirect_uri: config.POST_LOGOUT_REDIRECT_URL,
      client_id: config.CLIENT_ID,
      response_type: 'code',
      scope: 'openid role I4ProAuth.Security.Api I4ProPortal.Api IdentityServerApi',
      userStore: new oidc.WebStorageStateStore({ store: window.localStorage })
    });
  }

  throw new Error("Obrigatório passar como parâmetro uma configuração!");
}

export const validateClientID = (config, urlKeyToClientID) => {
  if (!config.CLIENT_ID_EXTERNAL) return config;

  let clientIdExternal = config.CLIENT_ID_EXTERNAL;

  const newConfig = clientIdExternal[Object.keys(clientIdExternal).find(keyURL => keyURL.toLowerCase() === urlKeyToClientID.toLowerCase() )];

  return !newConfig ? config : newConfig;
}
